/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 5/14/15.
 */
'use strict';
angular.module('prism-ui.components.navigation').service('PaginationService', function (
    $q
) {
	var PaginationService = this;

	this.pageNumberMap = undefined;

	this.updateCurrentPage = function () {
		if (!this.pageNumberMap) {
			var currentPage = Math.ceil(this.contentTotal / this.pageSize);

			if (this.totalPages === 0) {
				this.currentPage = 1;
			} else if (this.currentPage > currentPage) {
				this.currentPage = currentPage;
			}
		}
	};

	this.getNextItemInPage = function () {
		var deferred = $q.defer();

		if (this.currentPageItemIndex === this.pageSize - 1) {
			++this.currentPage;
			this.currentPageItemIndex = 0;
			return this.queryForNewPageData(deferred);
		} else {
			deferred.resolve(this.pageData[++this.currentPageItemIndex]);
			return deferred.promise;
		}
	};

	this.getPreviousItemInPage = function () {
		var deferred = $q.defer();
		if (this.currentPageItemIndex === 0) {
			--this.currentPage;
			this.currentPageItemIndex = this.pageSize - 1;
			return this.queryForNewPageData(deferred);
		} else {
			deferred.resolve(this.pageData[--this.currentPageItemIndex]);
			return deferred.promise;
		}
	};

	this.queryForNewPageData = function (deferred) {
		var queryOptions = {
			fetchOffset: this.pageSize * (this.currentPage - 1),
			fetchLimit: this.pageSize
		};
		this.pageDataResource.query(queryOptions).$promise.then(function (pageData) {
			PaginationService.pageData = pageData;
			deferred.resolve(PaginationService.pageData[PaginationService.currentPageItemIndex]);
		});
		return deferred.promise;
	};

	this.parseResponseHeaders = function (headers) {
		var contentRange = headers['content-range'];
        if (contentRange) {
			this.contentTotal = parseInt(contentRange.split('/')[1]);
			this.totalPages = Math.ceil(this.contentTotal / this.pageSize);
			this.totalPagesArray = [].constructor(this.totalPages);
			this.updateCurrentPage();
		}
	};

	this.resetToDefaultValues = function () {
		this.pageSizes = [10, 25, 50, 100, 500];
		this.pageSize = 25;
		this.currentPage = 1;
		this.totalPages = 0;
		this.currentPageItemIndex = 0;
		this.pageData = [];
		this.totalPagesArray = [];

		this.pageDataResource = null;
	};

	this.saveCurrentValues = function () {
		return {
			pageSizes: this.pageSizes,
			pageSize: this.pageSize,
			currentPage: this.currentPage,
			totalPages: this.totalPages,
			currentPageItemIndex: this.currentPageItemIndex
		};
	};

	this.restoreValues = function (values) {
		for (var prop in values) {
			this[prop] = values[prop];
		}
	};

	this.resetToDefaultValues();

});
